import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BackButton.module.css';

const BackButton = ({ label = '← Back' }) => {
    const navigate = useNavigate();
    return (
        <button className={styles.backButton} onClick={() => navigate(-1)}>
            {label}
        </button>
    );
};

export default BackButton;
